import { Menu } from '@app/core/shared/models/menu';
import { Element, ElementsInfo } from '../../models/element';

export class MenuItems {
  static getMenuItems(element?: Element): Menu[] {
    if (element) {
      return this.getElementSpecificMenu(element);
    }
    return [
      {
        menuId: 0,
        name: 'Elementz',
        description: 'Elementz',
        navigateUrls: ['elementz'],
        icon: 'token'
      },
      {
        menuId: 1,
        name: 'Users',
        description: 'Users',
        navigateUrls: ['users'],
        icon: 'group'
      },
      {
        menuId: 2,
        name: 'Hierarchy',
        description: 'Hierarchy',
        icon: 'account_tree',
        childMenus: [
          {
            menuId: 3,
            name: 'Hierarchy Definition',
            description: 'Hierarchy Definition',
            navigateUrls: ['hierarchySetUp']
          },
          {
            menuId: 4,
            name: 'Hierarchy Tree',
            description: 'Hierarchy Tree',
            navigateUrls: ['componentTree']
          }
        ]
      },
      {
        menuId: 5,
        name: 'Properties',
        description: 'Properties',
        icon: 'format_list_bulleted',
        childMenus: [
          {
            menuId: 6,
            name: 'Property Groups',
            description: 'Property Groups',
            navigateUrls: ['propertyGroups']
          },
          {
            menuId: 7,
            name: 'Properties',
            description: 'Properties',
            navigateUrls: ['properties']
          }
        ]
      }
    ];
  }

  private static getElementSpecificMenu(element: Element): Menu[] {
    // removes starting / that comes from database entry which messes up the urls
    const elementzUrl = element.url.substring(1);
    let menu: Menu[] = [
      {
        menuId: 0,
        name: 'Element Details',
        description: 'Element Details',
        icon: 'newsmode',
        navigateUrls: ['elementz', elementzUrl]
      },
      {
        menuId: 1,
        name: 'Hierarchy Definition',
        description: 'Hierarchy Definition',
        icon: 'flowchart',
        navigateUrls: ['elementz', elementzUrl, 'hierarchyDefinition']
      },
      {
        menuId: 2,
        name: 'Anomaly Management',
        description: 'Anomaly Management',
        icon: 'nearby_error',
        navigateUrls: ['elementz', elementzUrl, 'anomalyManagement']
      },
      {
        menuId: 3,
        name: 'Security Groups',
        description: 'Security Groups',
        icon: 'verified_user',
        navigateUrls: ['elementz', elementzUrl, 'securityGroups']
      },
      {
        menuId: 4,
        name: 'Media',
        description: 'Media',
        icon: 'perm_media',
        childMenus: [
          {
            menuId: 5,
            name: 'Media Types',
            description: 'Media Types',
            navigateUrls: ['elementz', elementzUrl, 'mediaTypes']
          },
          {
            menuId: 6,
            name: 'Media Locations',
            description: 'Media Locations',
            navigateUrls: ['elementz', elementzUrl, 'mediaLocations']
          },
          {
            menuId: 7,
            name: 'Media Categories',
            description: 'Media Categories',
            navigateUrls: ['elementz', elementzUrl, 'mediaCategory']
          },
          {
            menuId: 8,
            name: 'Media Library',
            description: 'Media Library',
            navigateUrls: ['elementz', elementzUrl, 'mediaLibrary']
          }
        ]
      },
      {
        menuId: 9,
        name: 'Element Specific Lists',
        description: 'Element Specific Lists',
        icon: 'dropdown',
        navigateUrls: ['elementz', elementzUrl, 'elementSpecificList']
      }
    ];

    if (element.elementId === ElementsInfo.SURF.elementId) {
      menu = [
        ...menu,
        {
          menuId: 10,
          name: 'Calculations',
          description: 'Calculations',
          icon: 'calculate',
          navigateUrls: ['elementz', elementzUrl, 'calculations']
        },
        {
          menuId: 11,
          name: 'Task Results',
          description: 'Task Results',
          icon: 'analytics',
          navigateUrls: ['elementz', elementzUrl, 'taskResults']
        }
      ];
    }

    return menu;
  }
}
